var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{class:_vm.classes,style:(_vm.styles),attrs:{"id":"logo","fluid-grow":"","src":"/api/v3/logo","alt":_vm.$t('components.title.logo-alt')}})}
var staticRenderFns = []

export { render, staticRenderFns }